import { render, staticRenderFns } from "./TrasladoDeAvlsModal.vue?vue&type=template&id=27280730"
import script from "./TrasladoDeAvlsModal.vue?vue&type=script&lang=js"
export * from "./TrasladoDeAvlsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports